import PropTypes from 'prop-types';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { AuthenticationForm, TextField } from './AuthenticationForm';
import { ButtonLink } from './ButtonLink';

const styles = (theme) => ({
  submitWrapper: {
    margin: '0 auto',
    width: '200px',
  },
  tabContainer: {},
  title: {},
});

const ChangePasswordTabComponent = ({ classes, handleTabChange, onClose, t, ...props }) => (
  <div className={classes.tabContainer}>
    <h1 className={classes.title}>{t('change_password', 'Change Password')}</h1>

    <AuthenticationForm
      classes={{ submitWrapper: classes.submitWrapper }}
      submitLabel={t('update', 'Update')}
      {...props}
    >
      <TextField
        name="currentPassword"
        type="password"
        label={t('enter_current_password', 'Enter current password')}
        required
      />
      <TextField
        name="password"
        type="password"
        label="Enter new password"
        label={t('enter_new_password', 'Enter new password')}
        inputProps={{ datacompare: 'true' }}
        required
      />
      <TextField
        name="confirmPassword"
        type="password"
        label="Re-enter new password"
        label={t('reenter_new_password', 'Re-enter new password')}
        inputProps={{ datacompare: 'true' }}
        required
      />
    </AuthenticationForm>

    <ButtonLink onClick={onClose}>{t('cancel', 'Cancel')}</ButtonLink>
  </div>
);
ChangePasswordTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  handleTabChange: PropTypes.func.isRequired,
};

export const ChangePasswordTab = withStyles(styles)(withNamespaces()(ChangePasswordTabComponent));
